/**
 *
 * Sidebar
 *
 */

import React from "react"
import { connect } from "react-redux"
import { push } from "connected-react-router"
import Strings from "utils/strings"
import { SidebarMenu, UserMenu } from "components"
import { setSidebarOpenGroups } from "store/actions"
import logo from "assets/images/logo.png"
import "./styles.scss"

export class Sidebar extends React.PureComponent<any, any> {
	constructor(props: any) {
		super(props)

		this.state = {
			activeTab: "/dashboard",
		}

		this.selectTab = this.selectTab.bind(this)
		this.goTo = this.goTo.bind(this)
		this.goToHomepage = this.goToHomepage.bind(this)
		this.toggleGroup = this.toggleGroup.bind(this)
	}

	selectTab(url: String) {
		const { activeTab } = this.state
		this.setState({ activeTab: activeTab === url ? "" : url })
	}

	goTo(url: String) {
		const clientWidth = document.body.clientWidth
		this.setState({ activeTab: url })
		this.props.onMobile(clientWidth < 992)
		this.props.dispatch(push(`/${url}`))
	}

	goToHomepage() {
		this.setState({ activeTab: "/dashboard" })
		this.props.dispatch(push("/"))
	}

	toggleGroup(group: string) {
		const { sidebarOpenGroups, dispatch } = this.props
		dispatch(
			setSidebarOpenGroups({
				...sidebarOpenGroups,
				[group]: !sidebarOpenGroups[group],
			})
		)
	}

	renderGroup(key: string, label: string, children: React.ReactNode) {
		const { open: sidebarIsOpen, sidebarOpenGroups } = this.props
		const expanded = sidebarOpenGroups[key]
		const isOpen = expanded || !sidebarIsOpen

		return (
			<div className="SidebarGroup">
				{sidebarIsOpen && (
					<div
						className="SidebarGroupHeader"
						onClick={() => this.toggleGroup(key)}
					>
						<span className="SidebarGroupLabel">{label}</span>
						<em className={`caret${expanded ? " __opened" : ""}`} />
					</div>
				)}
				<div className={`SidebarGroupItems${isOpen ? " open" : ""}`}>
					<div>{children}</div>
				</div>
			</div>
		)
	}

	render() {
		const { activeTab } = this.state
		const { open, user } = this.props
		const isSuper = (Boolean(user) && user.role === "sysadmin") || false
		const isAdmin = (Boolean(user) && user.role === "admin") || false
		const isOperations = (Boolean(user) && user.role === "operations") || false

		if (!user) {
			return null
		}

		return (
			<div className="SidebarWrapper">
				<div className={`SidebarContainer${open ? " open" : " closed"}`}>
					<div className="SidebarHome">
						<a
							className="SidebarLogoContainer"
							onClick={this.goToHomepage}
							href="/"
						>
							<img className="Logo" alt="Logo" src={logo} />
						</a>
						<div className="SidebarSeparator" />
					</div>
					<div className="SidebarContent">
						<UserMenu
							sidebarIsOpen={open}
							subMenus={[
								{
									name: Strings.header.account,
									icon: "user2",
								},
								{
									name: Strings.authentication.logout,
									action: "logout",
									icon: "logout",
								},
							]}
						/>
						<div style={{ margin: "10px 0" }} className="SidebarSeparator" />

						{(isSuper || isAdmin) &&
							this.renderGroup(
								"general",
								Strings.sidebar.groups.general,
								<SidebarMenu
									name={Strings.sidebar.dashboard}
									url="dashboard"
									icon="speedometer"
									activeTab={activeTab}
									onClick={this.goTo}
									sidebarIsOpen={open}
								/>
							)}

						{(isSuper || isAdmin) &&
							this.renderGroup(
								"operations",
								Strings.sidebar.groups.operations,
								<>
									<SidebarMenu
										name={Strings.sidebar.businesses}
										url="businesses"
										icon="partner"
										activeTab={activeTab}
										onClick={this.goTo}
										sidebarIsOpen={open}
									/>
									<SidebarMenu
										name={Strings.sidebar.orders}
										url="orders"
										icon="order"
										activeTab={activeTab}
										onClick={this.goTo}
										sidebarIsOpen={open}
									/>
									<SidebarMenu
										name={Strings.sidebar.routes}
										url="routes"
										icon="route"
										activeTab={activeTab}
										onClick={this.goTo}
										sidebarIsOpen={open}
									/>
									<SidebarMenu
										name={Strings.sidebar.externalDeliveries}
										url="external-deliveries"
										icon="route"
										activeTab={activeTab}
										onClick={this.goTo}
										sidebarIsOpen={open}
									/>
									<SidebarMenu
										name={Strings.sidebar.sectorsMap}
										url="sectors-map"
										icon="location"
										activeTab={activeTab}
										onClick={this.goTo}
										sidebarIsOpen={open}
									/>
								</>
							)}

						{(isSuper || isAdmin || isOperations) &&
							this.renderGroup(
								"team",
								Strings.sidebar.groups.team,
								<>
									{(isSuper || isAdmin) && (
										<SidebarMenu
											name={Strings.sidebar.staff}
											url="staff"
											icon="working-briefcase"
											activeTab={activeTab}
											onClick={this.goTo}
											sidebarIsOpen={open}
										/>
									)}
									{(isSuper || isAdmin) && (
										<SidebarMenu
											name={Strings.sidebar.messaging}
											url="messaging"
											icon="letter"
											activeTab={activeTab}
											onClick={this.goTo}
											sidebarIsOpen={open}
										/>
									)}
									<SidebarMenu
										name={Strings.sidebar.operationLinks}
										url="operation-links"
										icon="external-link"
										activeTab={activeTab}
										onClick={this.goTo}
										sidebarIsOpen={open}
									/>
								</>
							)}

						{(isSuper || isAdmin) &&
							this.renderGroup(
								"system",
								Strings.sidebar.groups.system,
								<>
									<SidebarMenu
										name={Strings.sidebar.settings}
										url="settings"
										icon="preferences"
										activeTab={activeTab}
										onClick={this.goTo}
										sidebarIsOpen={open}
									/>

									{isSuper && (
										<>
											{/* Tenants tab hidden until tenant development resumes.
											<SidebarMenu
												name={Strings.sidebar.tenants}
												url="tenants"
												icon="companhia"
												activeTab={activeTab}
												onClick={this.goTo}
												sidebarIsOpen={open} />
												*/}
											<SidebarMenu
												name={Strings.sidebar.logs}
												url="logs"
												icon="duplicate"
												activeTab={activeTab}
												onClick={this.goTo}
												sidebarIsOpen={open}
											/>
										</>
									)}
								</>
							)}
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = (state: any) => ({
	settings: state.settings,
	user: state.user,
	language: state.language,
	sidebarOpenGroups: state.sidebarOpenGroups || {},
})

export default connect(mapStateToProps)(Sidebar)
